export const translations = {
	'Create team': {
		no: 'Opprett team',
	},
	"You don't have enough permissions to perform this action.": {
		no: 'Du har ikke rettigheter til å utføre denne handlingen.',
	},
	'30d': {
		no: '30d',
	},
	'7d': {
		no: '7d',
	},
	'24h': {
		no: '24t',
	},
	'Hour': {
		no: 'Time',
	},
	'Upload failed': {
		no: 'Opplasting feilet',
	},
	'Added': {
		no: 'Lastet',
	},
	'Uploading': {
		no: 'Laster',
	},
	'Add image': {
		no: 'Legg til bilde...',
	},
	'Click here or maximize icon to see setting': {
		no: 'Klikk her eller maksimer ikonet for å se innstillingene',
	},
	'Account': {
		no: 'Konto',
	},
	'Category node': {
		no: 'Kategori node',
	},
	'Category path': {
		no: 'Kategori path',
	},
	'Instance name': {
		no: 'Instansnavn',
	},
	'Source name': {
		no: 'Kildenavn',
	},
	'Agent id': {
		no: 'Agent id',
	},
	'Unit type symbol': {
		no: 'Enhetstype symbol',
	},
	'Category id': {
		no: 'Kategori id',
	},
	'Account id': {
		no: 'Konto id',
	},
	'Algorithm': {
		no: 'Algoritme',
	},
	'Rule type': {
		no: 'Regeltype',
	},
	'Sample rate': {
		no: 'Samplingsrate',
	},
	'Invert': {
		no: 'Inverter',
	},
	'Breach value': {
		no: 'Brudd verdi',
	},
};
